export const activityScoreboardModalStyle = {
  content: {
    top: '5%',
    left: '5%',
    right: '5%',
    bottom: '5%',
    background: '#FFF',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    borderStyle: 'none',
    color: 'black',
    borderRadius: '1.5rem',
    padding: '0px',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
};

export const qrCodeModalStyles = {
  content: {
    top: "10%",
    left: "20%",
    right: "20%",
    bottom: "17.5%",
    background: "#FFF",
    padding: "0",
    borderStyle: "none",
    borderRadius: "1rem",
    boxShadow: "0px 4px 10px rgba(103, 107, 133, 0.15)",
    maxWidth: "40rem",
    height: "fit-content",
  },
};

export const newQuestionModalStyle = {
  content: {
    top: '10%',
    left: '8%',
    right: '8%',
    bottom: '10%',
    minHeight: '500px',
    background: 'rgba(242, 241, 240, 1)',
    color: 'black',
    padding: '0px',
    borderRadius: '1rem',
    border: 'none',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    overflow: 'visible',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const questionModalPreviewStyle = {
  content: {
    top: '20%',
    bottom: '60%',
    left: '30%',
    right: '30%',
    minWidth: '500px',
    minHeight: '250px',
    height: 'fit-content',
    background: 'rgba(242, 241, 240, 1)',
    color: 'black',
    padding: '0px',
    borderRadius: '1rem',
    border: 'none',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    overflow: 'visible',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const newEventModalStyle = {
  content: {
    top: '12%',
    left: '14%',
    right: '14%',
    bottom: '12%',
    background: '#FFF',
    padding: '0px',
    color: 'black',
    borderRadius: '20px',
    borderWidth: '0px',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const gameOverviewModalStyle = {
  content: {
    top: '5%',
    width: '1000px',
    margin: 'auto',
    bottom: '5%',
    background: '#FFF',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    borderStyle: 'none',
    color: 'black',
    borderRadius: '1.5rem',
    padding: '0',
    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const newMemberModalStyle = {
  content: {
    top: '20%',
    left: '20%',
    right: '20%',
    bottom: '100%',
    minHeight: '500px',
    background: 'rgba(242, 241, 240, 1)',
    color: 'black',
    padding: '0px',
    borderRadius: '1rem',
    border: 'none',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    overflow: 'visible',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const deleteModalStyles = {
  content: {
    top: "30%",
    left: "40%",
    right: "40%",
    bottom: "36%",
    background: "rgb(255, 255, 255)",
    padding: "20px 20px 40px 20px",
    textAlign: "center",
    borderRadius: "15px",
    borderStyle: "none",
    boxShadow: "0px 4px 10px rgba(103, 107, 133, 0.15)",
    height: "fit-content",
    width: "32rem",
    overflow: 'initial',
  },
};

export const customStylesModal = {
  content: {
    top: '5%',
    left: '5%',
    right: '5%',
    bottom: '5%',
    background: '#FFF',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    borderStyle: 'none',
    color: 'black',
    borderRadius: '1.5rem',
    padding: '0',
    overflow: 'initial',
  },
};

export const customStyles = {
  content: {
    top: '10%',
    left: '14%',
    right: '14%',
    bottom: '10%',
    background: '#FFF',
    padding: '0px',
    color: 'black',
    borderRadius: '20px',
    borderWidth: '0px',
    overflow: 'initial',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const gameOverviewStyle = {
  content: {
    top: '5%',
    width: '1000px',
    margin: 'auto',
    bottom: '5%',
    background: '#FFF',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    borderStyle: 'none',
    color: 'black',
    borderRadius: '1.5rem',
    padding: '0',
    overflow: 'initial',
//    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};

export const editCreatorModalStyles = {
  content: {
    top: '20%',
    left: '30%',
    right: '30%',
    bottom: '100%',
    minHeight: '32rem',
    background: 'rgba(242, 241, 240, 1)',
    color: 'black',
    padding: '0.0rem',
    borderRadius: '1.0rem',
    border: 'none',
    boxShadow: '0px 4px 10px rgba(103, 107, 133, 0.15)',
    overflow: 'visible',
  },
  overlay: {
    backgroundColor: 'rgba(155, 155, 155, 0.75)',
  },
};
